import React, { useEffect } from 'react';
import InfoPage from '@/components/InfoPage';
import { Check } from 'lucide-react';

const Precos = () => {
  // Load Mercado Pago subscription script
  useEffect(() => {
    if (!window.$MPC_loaded) {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.async = true;
      script.src = document.location.protocol + '//secure.mlstatic.com/mptools/render.js';
      document.body.appendChild(script);
      window.$MPC_loaded = true;
    }
  }, []);

  return (
    <InfoPage title="Preços">
      <div className="space-y-8">
        <div className="text-center">
          <h2 className="text-3xl font-bold mb-4" style={{ color: '#302681' }}>
            100% GRATUITO
          </h2>
          <p className="text-xl text-gray-600">
            Nossa missão é democratizar o acesso às tecnologias para estacionamentos. Por isso, o ParkingSpot tem a sua versão gratuita para uso.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mt-12">
          <div className="bg-gradient-to-br from-blue-50 to-purple-50 p-8 rounded-2xl border-2 border-[#302681]">
            <h3 className="text-2xl font-bold mb-4" style={{ color: '#302681' }}>Para Motoristas</h3>
            <div className="text-4xl font-bold mb-4" style={{ color: '#302681' }}>R$ 0</div>
            <p className="text-sm text-gray-600 mb-4">Grátis para sempre</p>
            <ul className="space-y-3">
              <li className="flex items-center space-x-2">
                <Check className="w-5 h-5 text-green-600" />
                <span>Busca ilimitada de estacionamentos</span>
              </li>
              <li className="flex items-center space-x-2">
                <Check className="w-5 h-5 text-green-600" />
                <span>Visualização em tempo real</span>
              </li>
              <li className="flex items-center space-x-2">
                <Check className="w-5 h-5 text-green-600" />
                <span>Navegação integrada</span>
              </li>
              <li className="flex items-center space-x-2">
                <Check className="w-5 h-5 text-green-600" />
                <span>Sem anúncios</span>
              </li>
            </ul>
          </div>

          <div className="bg-gradient-to-br from-red-50 to-orange-50 p-8 rounded-2xl border-2 border-[#831D1C]">
            <h3 className="text-2xl font-bold mb-4" style={{ color: '#831D1C' }}>Proprietários Básico</h3>
            <div className="text-4xl font-bold mb-4" style={{ color: '#831D1C' }}>R$ 0</div>
            <p className="text-sm text-gray-600 mb-4">Grátis para sempre</p>
            <ul className="space-y-3">
              <li className="flex items-center space-x-2">
                <Check className="w-5 h-5 text-green-600" />
                <span>Cadastro gratuito</span>
              </li>
              <li className="flex items-center space-x-2">
                <Check className="w-5 h-5 text-green-600" />
                <span>Gestão ilimitada de vagas</span>
              </li>
              <li className="flex items-center space-x-2">
                <Check className="w-5 h-5 text-green-600" />
                <span>Dashboard completo</span>
              </li>
              <li className="flex items-center space-x-2">
                <Check className="w-5 h-5 text-green-600" />
                <span>Atualizações em tempo real</span>
              </li>
              <li className="flex items-center space-x-2">
                <Check className="w-5 h-5 text-green-600" />
                <span>O ParkingSpot cobra apenas 0.45% das transações</span>
              </li>
            </ul>
          </div>

          <div className="bg-gradient-to-br from-yellow-50 to-amber-50 p-8 rounded-2xl border-4 border-[#FFCB00] relative overflow-hidden shadow-xl">
            <div className="absolute top-0 right-0 bg-[#FFCB00] text-white px-4 py-1 text-sm font-bold">
              PREMIUM
            </div>
            <h3 className="text-2xl font-bold mb-4 mt-4" style={{ color: '#302681' }}>Proprietários Premium</h3>
            <div className="flex items-baseline mb-4">
              <span className="text-4xl font-bold" style={{ color: '#302681' }}>R$ 15,90</span>
              <span className="text-gray-600 ml-2">/mês</span>
            </div>
            <p className="text-sm font-semibold mb-4" style={{ color: '#831D1C' }}>Recursos avançados para seu negócio</p>
            <ul className="space-y-3">
              <li className="flex items-center space-x-2">
                <Check className="w-5 h-5 text-green-600" />
                <span><strong>Processamento de pagamentos</strong> integrado com parceiros comerciais</span>
              </li>
              <li className="flex items-center space-x-2">
                <Check className="w-5 h-5 text-green-600" />
                <span>Relatórios e analytics avançados</span>
              </li>
              <li className="flex items-center space-x-2">
                <Check className="w-5 h-5 text-green-600" />
                <span>Sistema de reservas online</span>
              </li>
              <li className="flex items-center space-x-2">
                <Check className="w-5 h-5 text-green-600" />
                <span>Prioridade no suporte técnico</span>
              </li>
              <li className="flex items-center space-x-2">
                <Check className="w-5 h-5 text-green-600" />
                <span>Destaque no mapa para maior visibilidade</span>
              </li>
              <li className="flex items-center space-x-2">
                <Check className="w-5 h-5 text-green-600" />
                <span>Campanhas promocionais</span>
              </li>
            </ul>
            <a 
              href="https://www.mercadopago.com.br/subscriptions/checkout?preapproval_plan_id=13cfdb785f6a482684dd9a36c51855c8" 
              name="MP-payButton" 
              className="block w-full mt-6 py-3 rounded-lg font-bold text-white text-center transition-all hover:opacity-90"
              style={{ backgroundColor: '#3483FA', textDecoration: 'none' }}
            >
              Assinar Premium
            </a>
          </div>
        </div>

        <div className="bg-yellow-50 border-l-4 border-yellow-400 p-6 rounded">
          <p className="text-lg font-semibold text-yellow-800 mb-2">
            Importante:
          </p>
          <p className="text-yellow-700">
            O ParkingSpot não cobra taxas. Os preços exibidos são definidos pelos próprios proprietários dos estacionamentos.
          </p>
        </div>
      </div>
    </InfoPage>
  );
};

export default Precos;
